import React from 'react'
import CardUI from '../../../../widgets/layout/CardUI'
import GenericErrorUI from '../../../../components/common/GenericErrorUI'
import LRTableActionsUI from '../../../../widgets/layout/LRTableActionsUI'
import LRTableBodyUI from '../../../../widgets/layout/LRTableBodyUI'
import LRTableRowUI from '../../../../widgets/layout/LRTableRowUI'
import IconButtonUI from '../../../../widgets/action/IconButtonUI'
import SpinnerComponentUI from '../../../../components/common/SpinnerComponentUI'
import LoanMappingCreateModalSF from './LoanMappingCreateModalSF'
import LoanMappingUpdateModalSF from './LoanMappingUpdateModalSF'

const LoanMappingListUI = ({context, loan, mappingList, errorList, categoryLabel,
    // modes
    createMode, updateMode, selectedMapping,
    // event handlers
    onRefreshClick, onCreateClick, onUpdateClick, onCancelClick, onUpdate
}) =>
  <CardUI className='c_su_l_maps g_m_top_100' title={categoryLabel}>
    {
        errorList && errorList.length > 0 &&
        <GenericErrorUI error={errorList[0]} />
    }
    <LRTableActionsUI location='top'
        left={
            <ActionLeftUI context={context}
                onRefreshClick={onRefreshClick} onCreateClick={onCreateClick} />
        }
        right={<span />}
    />

    {
        mappingList && mappingList.length === 0 &&
        <div className='g_text_center'>No mappings yet</div>
    }

    {
      mappingList && mappingList.length > 0 &&
      <LRTableBodyUI>
        {
          mappingList.map((mapping, i) =>
            <LRTableRowUI key={i}
              context={context}
              left={<RowLeftUI context={context} mapping={mapping} />}
              right={<RowRightUI mapping={mapping} onUpdateClick={onUpdateClick} />}
            />
          )
        }
      </LRTableBodyUI>
    }

    <LoanMappingCreateModalSF
        loan={loan}
        context={context}
        createMode={createMode}
        onCancelClick={onCancelClick}
        onRefreshClick={onRefreshClick}
    />

    <LoanMappingUpdateModalSF
        loan={loan}
        context={context}
        updateMode={updateMode}
        onCancelClick={onCancelClick}
        onRefreshClick={onRefreshClick}
        selectedMapping={selectedMapping}
    />
  </CardUI>

const RowLeftUI = ({ mapping }) =>
    <div className='g_flex_h'>
        <span>{mapping.sourceValue}</span>
    </div>

const RowRightUI = ({ mapping, onUpdateClick }) =>
    <div className='g_flex_h'>
        <span>{mapping.mappedValue}</span>
        <span className='icon icon-pencil g_link_2 g_m_left_50'
            data-mapping-id={mapping.loanMappingId} onClick={onUpdateClick} />
    </div>

const ActionLeftUI = ({ onRefreshClick, onCreateClick }) =>
    <div className='g_flex_h'>
        <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
        <IconButtonUI icon='icon-plus' onClick={onCreateClick} />
    </div>

export default LoanMappingListUI
